var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
const u = up.util;
up.RenderJob = (_a = class RenderJob {
        constructor(renderOptions) {
            this.renderOptions = renderOptions;
        }
        execute() {
            this._rendered = this._executePromise();
            return this;
        }
        _executePromise() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    this._emitGuardEvent();
                    this.renderOptions = up.RenderOptions.preprocess(this.renderOptions);
                    up.browser.assertConfirmed(this.renderOptions);
                    up.RenderOptions.assertContentGiven(this.renderOptions);
                    let result = yield this._getChange().execute();
                    this._handleResult(result);
                    return result;
                }
                catch (resultOrError) {
                    this._handleResult(resultOrError) || this._handleError(resultOrError);
                    throw resultOrError;
                }
            });
        }
        _handleResult(result) {
            if (result instanceof up.RenderResult) {
                let { onRendered, onFinished } = result.renderOptions;
                if (!result.none)
                    up.error.guard(() => onRendered === null || onRendered === void 0 ? void 0 : onRendered(result));
                let guardedOnFinished = function (result) {
                    up.error.guard(() => onFinished === null || onFinished === void 0 ? void 0 : onFinished(result));
                };
                this.finished.then(guardedOnFinished, u.noop);
                return true;
            }
        }
        _handleError(error) {
            let prefix = error instanceof up.Aborted ? 'Rendering was aborted' : 'Error while rendering';
            up.puts('up.render()', `${prefix}: ${error.name}: ${error.message}`);
            up.error.guard(() => { var _b, _c; return (_c = (_b = this.renderOptions).onError) === null || _c === void 0 ? void 0 : _c.call(_b, error); });
        }
        get finished() {
            return this._awaitFinished();
        }
        _awaitFinished() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let result = yield this._rendered;
                    return yield result.finished;
                }
                catch (error) {
                    if (error instanceof up.RenderResult) {
                        throw yield error.finished;
                    }
                    else {
                        throw error;
                    }
                }
            });
        }
        _getChange() {
            let handleAbort = u.memoize((request) => this._handleAbortOption(request));
            let renderOptions = Object.assign(Object.assign({}, this.renderOptions), { handleAbort });
            if (renderOptions.url) {
                return new up.Change.FromURL(renderOptions);
            }
            else if (renderOptions.response) {
                return new up.Change.FromResponse(renderOptions);
            }
            else {
                return new up.Change.FromContent(renderOptions);
            }
        }
        _emitGuardEvent() {
            let guardEvent = u.pluckKey(this.renderOptions, 'guardEvent');
            if (guardEvent) {
                guardEvent.renderOptions = this.renderOptions;
                if (up.emit(guardEvent, { target: this.renderOptions.origin }).defaultPrevented) {
                    throw new up.Aborted(`Rendering was prevented by ${guardEvent.type} listener`);
                }
            }
        }
        _handleAbortOption({ bindFragments, bindLayer, origin, layer, request }) {
            let { abort } = this.renderOptions;
            if (!abort)
                return;
            let abortOptions = {
                except: request,
                logOnce: ['up.render()', 'Change with { abort } option will abort other requests'],
                newLayer: (layer === 'new'),
                origin,
                jid: this.renderOptions.jid,
            };
            if (abort === 'target') {
                up.fragment.abort(bindFragments, Object.assign({}, abortOptions));
            }
            else if (abort === 'layer') {
                up.fragment.abort(Object.assign(Object.assign({}, abortOptions), { layer: bindLayer }));
            }
            else if (abort === 'all' || abort === true) {
                up.fragment.abort(Object.assign(Object.assign({}, abortOptions), { layer: 'any' }));
            }
            else if (u.isFunction(abort)) {
                abort(abortOptions);
            }
            else {
                up.fragment.abort(abort, Object.assign(Object.assign({}, abortOptions), { layer: bindLayer }));
            }
        }
    },
    (() => {
        u.delegatePromise(_a.prototype, function () { return this._rendered; });
        u.memoizeMethod(_a.prototype, {
            _awaitFinished: true,
            _getChange: true,
        });
    })(),
    _a);
